/**
 * Configurable Axios HTTP client for API requests
 * Consuming applications should configure this instance with baseURL and interceptors
 * Axios is picked because SS-UI already uses it and it's widely adopted. This makes it easy to just standardize on.
 * Subsequent shared API requests can then assume that this instance will be configured by the consuming application to meet its needs.
 */

import axios from 'axios';

/**
 * Shared axios instance for all API calls in client-common
 * Configure this instance in your application before making API calls
 */
export const httpClient = axios.create();
